"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("react");
const PlayIcon_1 = require("../../../icons/PlayIcon");
const IconButton_1 = require("../IconButton");
const PlayButton_module_css_1 = __importDefault(require("./PlayButton.module.css"));
/**
 * Play button for media playback
 */
function PlayButton({ isOnPlay, handleClick }) {
    const togglePlay = (0, react_1.useCallback)(() => {
        handleClick(!isOnPlay);
    }, [isOnPlay, handleClick]);
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(PlayButton_module_css_1.default.playButtonContainer, "playButtonContainer"), onClick: togglePlay, "data-testid": "playButton", children: !isOnPlay && ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { size: "LARGE", label: "Play Video", children: (0, jsx_runtime_1.jsx)(PlayIcon_1.PlayIcon, {}) })) }));
}
exports.PlayButton = PlayButton;
//# sourceMappingURL=PlayButton.js.map